import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

export const textFieldStyles = style({
  flexGrow: 1,
  $nest: {
    '& input': {
      width: '100%'
    }
  }
});

export const dialogBodyStyles: React.CSSProperties = {
  display: 'inline-block',
  width: '100%'
};

export const groupSetNameFieldStyles: React.CSSProperties = {
  width: '380px'
};

export const outerCheckboxStyles: React.CSSProperties = {
  marginBottom: TabStyles.Spacing.DefaultSpace
};

export const dialogElementStyles: React.CSSProperties = {
  display: 'inline-flex'
};

export const labelStyles: React.CSSProperties = {
  width: '150px',
};